module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col bg-white"
  }, [(_vm.courselist_loading) ? _c('div', {
    staticClass: "flex h-screen items-center justify-center"
  }, [_c('pl-spinner', {
    staticClass: "x3"
  })], 1) : _c('div', {
    staticClass: "flex-grow"
  }, [_c('DefaultLayout', [_c('CourseTable')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3ad63ddb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/dashboard/myCourses.vue
// module id = 1645
// module chunks = 61